import { api } from './api';

export const reportApi = api.injectEndpoints({
  endpoints: builder => ({
    getJudgePerformance: builder.query({
      query: ({ campId, judgeId }) => {
        let url = `/reports/judge-performance?campId=${campId}`
        if (judgeId) url += `&judgeId=${judgeId}`
        return url
      },
    }),
    getEventPerformance: builder.query({
      query: ({ campId }) => `/reports/event-performance?campId=${campId}`,
      providesTags: ['EventPerformance'],
    }),
    calculatePerformance: builder.mutation({
      query: ({ campId }) => ({
        url: '/reports/calculate-performance',
        method: 'POST',
        body: { campId },
      }),
    }),
    getCalculateStatus: builder.query({
      query: ({ campId }) => `/reports/calculate-status?campId=${campId}`,
    }),
  }),
  overrideExisting: false,
})

export const {
  useGetJudgePerformanceQuery,
  useGetEventPerformanceQuery,
  useCalculatePerformanceMutation,
  useGetCalculateStatusQuery,
} = reportApi
